export const BREADCRUMBS_TRANSLATE = {
    breadcrumbs: {
        new: "Agregar",
        update: "Editar",
        visualization: "Ver",
    }
};
